import { generateWidgetContext } from '../widget-wrapper';

export const FavoritesWidgetContext = generateWidgetContext();
